import React from 'react'
import { Checkbox, Segment, Form, Dropdown as UnstyledDropdown } from 'semantic-ui-react'
import styled from 'styled-components'
import classNames from 'classnames'
import { questionMap } from 'domains/survey'

const Dropdown = styled(UnstyledDropdown)`
  > div.text {
    display: inline-flex !important;
    align-items: center;
  }
`

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 116px !important;
  max-width: 116px;
  text-align: center;
  background-color: '#f4f4f4' !important;
  font-weight: bold;
`

const Content = styled(Segment)`
  padding-right: 40px !important;
  @media only screen and (min-width: 768px) {
    padding: 26px 80px 26px 60px !important;
  }
`

const ContentWrapper = styled.div`
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (min-width: 768px) {
    max-width: unset;
  }
`

const LabelInDropdown = styled.span`
  font-size: 1.125em;
  line-height: 1em;
`
const DropdownWrapper = styled(Dropdown)`
  &.ui.selection.dropdown.disabled {
    background: rgba(244, 244, 244, 0.8);
    color: #373f46;
    opacity: 1;
  }
`

export default function QuestionPreviewCard({ question, keyIndex, onSelectQuestion }) {
  const questionTypeDisplay = questionMap[question.type]

  return (
    <Form>
      <Segment.Group horizontal>
        <Sidebar className="pt0 mt4 shadow-none">
          <Checkbox onChange={(_, { checked }) => onSelectQuestion(keyIndex, checked)} />
        </Sidebar>
        <Content className="shadow-none">
          <ContentWrapper>
            {questionTypeDisplay && (
              <Form.Field>
                <label>Question type</label>
                <DropdownWrapper
                  text={
                    <React.Fragment>
                      <i
                        className={classNames('icon ', questionTypeDisplay.iconClassName)}
                        style={{ fontSize: '1.2em' }}
                      />
                      <LabelInDropdown>{questionTypeDisplay.label}</LabelInDropdown>
                    </React.Fragment>
                  }
                  icon=""
                  selection
                  disabled
                />
              </Form.Field>
            )}
            <Form.Field>
              <label>Question</label>
              <DropdownWrapper
                text={
                  <React.Fragment>
                    <LabelInDropdown>{question.text}</LabelInDropdown>
                  </React.Fragment>
                }
                icon=""
                selection
                disabled
                readOnly
              />
            </Form.Field>

            {question.type == 'multipleChoice' || question.type == 'multi_select_choice' ? (
              <Form.Field>
                <label>Choices</label>
                {question.choices.map((choice, index) => {
                  return (
                    <DropdownWrapper
                      key={index}
                      className="mt-2"
                      text={
                        <React.Fragment>
                          <LabelInDropdown>{choice.label}</LabelInDropdown>
                        </React.Fragment>
                      }
                      icon=""
                      selection
                      disabled
                    />
                  )
                })}
              </Form.Field>
            ) : null}

            {question.type == 'slider' && (
              <Form.Group widths="equal" className="field">
                <Form.Field>
                  <label>Min score</label>
                  <DropdownWrapper
                    className="mt-2"
                    text={
                      <React.Fragment>
                        <LabelInDropdown>{question.leftSideLabel}</LabelInDropdown>
                      </React.Fragment>
                    }
                    icon=""
                    selection
                    disabled
                  />
                </Form.Field>
                <Form.Field>
                  <label>Max score</label>
                  <DropdownWrapper
                    className="mt-2"
                    text={
                      <React.Fragment>
                        <LabelInDropdown>{question.rightSideLabel}</LabelInDropdown>
                      </React.Fragment>
                    }
                    icon=""
                    selection
                    disabled
                  />
                </Form.Field>
              </Form.Group>
            )}
          </ContentWrapper>
        </Content>
      </Segment.Group>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/QuestionPreviewCard/index.js